import { useContext } from 'react';
import CustomChannelHistoryListContext from './custom-channel-history-list-context';

export default function useCustomChannelHistoryList() {
  return useContext(CustomChannelHistoryListContext);
}
